/**
 * Shared line-item unit options.
 *
 * Single source of truth for the dropdown values used on:
 *   - InvoiceEdit "Unit" column (the user-facing per-row unit on the live invoice page).
 *   - QuoteBuilder "Unit" column (must mirror invoice so quote-to-invoice carries units faithfully).
 *   - ServiceNotesModal "Unit" column (the Custom Item / quick-line editor).
 *
 * Why centralised: previously each surface declared its own option list,
 * leading to drift (the invoice had Litre/kg/Set/Pack; the quote and
 * custom-item editor had none, so SM had to re-type units after every
 * conversion). Aligning the lists keeps the formula the same EVERYWHERE
 * — `line_total = qty × unit_price` for simple rows; quantity selectors
 * + unit labels stay consistent across every edit surface.
 */

export const UNIT_OPTIONS = [
  { value: 'each', label: 'Each' },
  { value: 'hours', label: 'Hours' },
  { value: 'litre', label: 'Litre' },
  { value: 'kg', label: 'kg' },
  { value: 'set', label: 'Set' },
  { value: 'pack', label: 'Pack' },
];

/** Quick lookup for a label given a unit value (defaults to "Each"). */
export const labelForUnit = (value) => {
  const match = UNIT_OPTIONS.find((u) => u.value === value);
  return match ? match.label : 'Each';
};
